module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login-modal"
  }, [_c('h2', [_c('translate', {
    attrs: {
      "translate-context": "login popup"
    }
  }, [_vm._v("Please log-in")])], 1), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.login($event)
      }
    }
  }, [_c('p', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "email",
      "name": "mtopara-email",
      "placeholder": _vm.$pgettext('login popup', 'Email')
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "password"
  }, [_c('a', {
    staticClass: "show",
    attrs: {
      "href": "#",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.togglePassword($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-eye"
  })]), _vm._v(" "), (_vm.showPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "text",
      "name": "password",
      "autocomplete": "off",
      "placeholder": _vm.$pgettext('login popup', 'Password')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": _vm.$pgettext('login popup', 'Password')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.success) ? _c('p', {
    staticClass: "high success"
  }, [_c('translate', {
    attrs: {
      "translate-context": "login popup"
    }
  }, [_vm._v("\n        Welcome!\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.badLogin) ? _c('p', {
    staticClass: "error high"
  }, [_c('translate', {
    attrs: {
      "translate-context": "login popup"
    }
  }, [_vm._v("\n        Error! Bad login or password\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticClass: "error high"
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("\n        An error has occured. Please try again.\n      ")])], 1) : _vm._e(), _vm._v(" "), (_vm.expired) ? _c('p', {
    staticClass: "error high"
  }, [_c('translate', {
    attrs: {
      "translate-context": "login popup",
      "translate-params": {
        expirationDate: _vm.expirationDate
      }
    }
  }, [_vm._v("\n        Error! Your access has expired on %{ expirationDate }.\n      ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.contribute()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "login popup"
    }
  }, [_vm._v("Click here to renew.")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "keyboard-submit-bug-fix"
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("OK")])], 1)]), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "high"
  }, [_c('img', {
    attrs: {
      "src": "/img/load.gif"
    }
  })]) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.success) ? _c('p', {
    staticClass: "high"
  }, [_c('button', {
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("OK")])], 1), _vm._v(" "), _c('button', {
    staticClass: "light",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "popup"
    }
  }, [_vm._v("Close")])], 1)]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "high"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.go('password')
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "login popup"
    }
  }, [_vm._v("Already a member? Click to reset your password")])], 1)]), _vm._v(" "), _c('p', {
    staticClass: "high"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.contribute()
      }
    }
  }, [_c('translate', {
    attrs: {
      "translate-context": "login popup"
    }
  }, [_vm._v("Not a member yet? Click to get an access code")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64359c9f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/login.vue
// module id = 339
// module chunks = 1